import Model from '@/models/Model.js';

export default class SectionSettings extends Model {
    static entity = 'section_settings';

    static fields() {
        return {
            id: this.attr(null),
            section_settings_template_id: this.attr(null),
            visible_at: this.attr(null),
            type: this.attr(null),
            week_number: this.attr(null),
            week_start: this.attr(null),
            week_end: this.attr(null),

            ...super.fields(),

            section_settings_template: this.belongsTo('section_settings_templates', 'section_settings_template_id'),
            section: this.hasOne('sections', 'section_settings_id'),
        };
    }

    get week_range_display() {
        return `${this.timestamp('week_start').format('M/D')} - ${this.timestamp('week_end').format('M/D')}`;
    }
}
